import React, { Component, Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query, ApolloConsumer } from 'react-apollo'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Select from 'react-select'
import CustomerDetailsCard from '../../Modules/CustomerDetailsCard'
import PartnerSubscriptionDetailsEdit from './PartnerSubscriptionDetailsEdit'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import getLoginId from '../../../utils/getLoginId'
import Loader from '../../../components/common/Loader'
import ConfirmationalDialog from '../../common/ConfirmationDialog'

// const GET_CLIENTS = gql`
//   query allClientDetails($partnerLoginId: Int) {
//     clients: allClientDetails(partnerLoginId: $partnerLoginId) {
//       id
//       clientName
//       loginId
//     }
//   }
// `

// const GET_CLIENT = gql`
//   query clientDetail($id: Int) {
//     clientDetail(loginId: $id) {
//       id
//       clientName
//       contactPerson
//       address
//       city
//       state {
//         zone_id
//         name
//       }
//       country {
//         country_id
//         name
//       }
//       email
//       contactNumber
//       login {
//         username
//       }
//       pincode
//       panNumber
//     }
//   }
// `

const GET_PARTNER_SUBSCRIPTION = gql`
  query getPartnerSubscriptions($subscriptionId: Int!) {
    partnerSubscription: getPartnerSubscriptions(id: $subscriptionId) {
      id
      partnerLoginId
      status
      partnerDetail {
        id
        businessName
      }
      billingFrequency {
        id
        frequency
      }
      deviceModel {
        model_name
      }
      accessoryType {
        accessoryName
      }
      serviceProvider {
        name
      }
      noOfDevices
      nextPaymentDate
      totalSoftwareQty
      billingMode {
        id
        billingMode
      }
      billingDetails {
        paymentId
        totalAmount
        totalAmountWithGST
        softwareBill {
          quantity
          rate
          amountWithGST
        }
        hardwareBill {
          quantity
          rate
          amountWithGST
        }
        accessoryBill {
          quantity
          rate
          amountWithGST
        }
        simBill {
          quantity
          rate
          amountWithGST
        }
      }
    }
  }
`
const UPDATE_PARTNER_SUBSCRIPTION = gql`
  mutation updatePartnerSubscriptions(
    $partnerSubscriptionId: Int!
    $partnerLoginId: Int!
    $billingFrequencyId: Int!
    $hardwareQuantity: Int!
    $softwareQuantity: Int!
    $accessoryQuantity: Int!
    $simQuantity: Int!
  ) {
    updatePartnerSubscriptions(
      partnerSubscriptionId: $partnerSubscriptionId
      partnerLoginId: $partnerLoginId
      billingFrequencyId: $billingFrequencyId
      hardwareQuantity: $hardwareQuantity
      softwareQuantity: $softwareQuantity
      accessoryQuantity: $accessoryQuantity
      simQuantity: $simQuantity
    )
  }
`

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  input: {
    display: 'flex',
    padding: 0
  }
})

// function ClientSelected(props) {
//   const isClientSelected = props.isClientSelected
//   if (isClientSelected) {
//     return (
//       <Grid container spacing={16}>
//         <Grid item xs={12}>
//           <CustomerDetailsCard clientDetail={props.clientDetails} />
//         </Grid>
//       </Grid>
//     )
//   }
//   return null
// }

function ShowSubDetails(props) {
  return (
    <Fragment>
      <ConfirmationalDialog
        isDialogOpen={props.isUpdateConfDialogOpen}
        dialogMessage={'Are you sure you want to Update this subscription?'}
        negativeResponseHandler={props.updateNegativeResponseHandler}
        positiveResponseHandler={props.updatePositiveResponseHandler}
      />
      <ConfirmationalDialog
        isDialogOpen={props.isCancelConfDialogOpen}
        dialogMessage={'Are you sure you want to Cancel the changes?'}
        negativeResponseHandler={props.cancelNegativeResponseHandler}
        positiveResponseHandler={props.cancelPositiveResponseHandler}
      />
      <PartnerSubscriptionDetailsEdit
        subscriptionData={props.subscriptionData}
        billingFrequencyId={props.billingFrequencyId}
        nextPaymentDate={props.nextPaymentDate}
        totalQuantity={props.totalQuantity}
        deviceQuantity={props.deviceQuantity}
        accessoryQuantity={props.accessoryQuantity}
        simQuantity={props.simQuantity}
        softwareQuantity={props.softwareQuantity}
        deviceTotalAmount={props.deviceTotalAmount}
        softwareTotalAmount={props.softwareTotalAmount}
        accessoryTotalAmount={props.accessoryTotalAmount}
        simTotalAmount={props.simTotalAmount}
        handleSelectChange={props.handleSelectChange}
        handleSelectDayChange={props.handleSelectDayChange}
        handleSelectGstChange={props.handleSelectGstChange}
        handleChange={props.handleChange}
        handleSelectBillingModeChange={props.handleSelectBillingModeChange}
        handleCancelClick={props.handleCancelClick}
        handleUpdateClick={props.handleUpdateClick}
      />
    </Fragment>
  )
}

class EditPartnerSubscription extends Component {
  constructor(props) {
    super(props)

    this.subscriptionId = this.props.match.params.subscriptionId
    this.loginId = this.props.match.params.loginId
    this.state = {
      subscriptionData: null,
      isUpdateConfDialogOpen: false,
      isCancelConfDialogOpen: false,
      billingFrequencyId: null,
      nextPaymentDate: null,
      totalQuantity: null,
      modelName: null,
      accessoryName: null,
      serviceProvider: null,
      deviceQuantity: 0,
      softwareQuantity: 0,
      accessoryQuantity: 0,
      simQuantity: 0,
      oldSoftwareQuantity: 0,
      oldDeviceQuantity: 0,
      oldAccessoryQuantity: 0,
      oldSimQuantity: 0,
      deviceTotalAmount: 0,
      softwareTotalAmount: 0,
      accessoryTotalAmount: 0,
      simTotalAmount: 0,
      grandTotalAmount: null,
      initStatus: {
        deviceQuantity: 0,
        accessoryQuantity: 0,
        simQuantity: 0,
        softwareQuantity: 0
      },
      isLoading: true
    }
  }

  handleChange = name => event => {
    console.log('change values')
    const {
      billingDetails: { softwareBill, hardwareBill, accessoryBill, simBill }
    } = this.state.subscriptionData
    if (
      !(event.target.value < this.state.initStatus[name]) &&
      event.target.value >= 0
    ) {
      console.log(name)
      if (name === 'softwareQuantity') {
        let total = event.target.value * softwareBill.rate
        this.setState({
          softwareTotalAmount: total,
          softwareQuantity: event.target.value
        })
      } else if (name === 'deviceQuantity') {
        console.log(event.target.value)
        let total = event.target.value * hardwareBill.rate
        this.setState({
          deviceTotalAmount: total,
          [name]: event.target.value
        })
      } else if (name === 'accessoryQuantity') {
        let total = event.target.value * accessoryBill.rate
        this.setState({
          accessoryTotalAmount: total,
          [name]: event.target.value
        })
      } else if (name === 'simQuantity') {
        let total = event.target.value * simBill.rate
        this.setState({
          simTotalAmount: total,
          [name]: event.target.value
        })
      }
    }
  }

  handleCancelClick = e => {
    this.setState({ isCancelConfDialogOpen: true })
  }

  handleUpdateClick = e => {
    this.setState({ isUpdateConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleUpdateNegativeResponse = e => {
    this.setState({ isUpdateConfDialogOpen: false })
  }

  handleCancelSubscription = e => {
    this.props.history.goBack()
  }

  handleUpdateSubscription = async event => {
    if (
      parseInt(this.state.deviceQuantity, 10) !==
      parseInt(this.state.softwareQuantity, 10)
    ) {
      this.props.openSnackbar(
        'Device total quantity and device quantity should be equal'
      )
    } else if (
      parseInt(this.state.deviceQuantity, 10) ===
        parseInt(this.state.oldDeviceQuantity, 10) &&
      parseInt(this.state.softwareQuantity, 10) ===
        parseInt(this.state.oldSoftwareQuantity, 10) &&
      parseInt(this.state.accessoryQuantity, 10) ===
        parseInt(this.state.oldAccessoryQuantity, 10) &&
      parseInt(this.state.simQuantity, 10) ===
        parseInt(this.state.oldSimQuantity, 10)
    ) {
      this.props.openSnackbar('No changes are made in the request')
    } else {
      const { data } = await this.props.client.mutate({
        mutation: UPDATE_PARTNER_SUBSCRIPTION,
        variables: {
          partnerSubscriptionId: parseInt(this.subscriptionId, 10),
          partnerLoginId: parseInt(this.loginId, 10),
          billingFrequencyId: parseInt(this.state.billingFrequencyId, 10),
          hardwareQuantity: parseInt(this.state.deviceQuantity, 10),
          softwareQuantity: parseInt(this.state.softwareQuantity, 10),
          accessoryQuantity: parseInt(this.state.accessoryQuantity, 10),
          simQuantity: parseInt(this.state.simQuantity, 10)
        }
      })
      if (data.updatePartnerSubscriptions === true) {
        this.props.openSnackbar('Subscription Updation Successful')
        this.props.history.push({
          pathname: '/home/users/partner'
        })
      } else {
        this.props.openSnackbar('Subscription Updation Failed')
      }
    }
  }

  componentDidMount() {
    this.getAllDetails()
  }

  getAllDetails = async () => {
    let initStatus = {
      deviceQuantity: 0,
      accessoryQuantity: 0,
      simQuantity: 0,
      softwareQuantity: 0
    }

    const { data, loading, error } = await this.props.client.query({
      query: GET_PARTNER_SUBSCRIPTION,
      variables: {
        subscriptionId: parseInt(this.props.match.params.subscriptionId, 10)
      },
      fetchPolicy: 'network-only'
    })

    if (data && data.partnerSubscription) {
      const { partnerSubscription } = data
      this.setState({ subscriptionData: partnerSubscription, isLoading: false })
      console.log('Edit subscription data:', data)

      // Maintain initial settings
      if (partnerSubscription.billingDetails) {
        const {
          billingDetails: { softwareBill, hardwareBill, accessoryBill, simBill }
        } = partnerSubscription
        if (hardwareBill) {
          initStatus['deviceQuantity'] = hardwareBill.quantity
          this.setState({
            deviceQuantity: hardwareBill.quantity,
            oldDeviceQuantity: hardwareBill.quantity,
            deviceTotalAmount: hardwareBill.quantity * hardwareBill.rate
          })
        }
        if (softwareBill) {
          initStatus['softwareQuantity'] = softwareBill.quantity
          this.setState({
            softwareQuantity: softwareBill.quantity,
            oldSoftwareQuantity: softwareBill.quantity,
            softwareTotalAmount: softwareBill.quantity * softwareBill.rate
          })
        }
        if (accessoryBill) {
          initStatus['accessoryQuantity'] = accessoryBill.quantity
          this.setState({
            accessoryQuantity: accessoryBill.quantity,
            oldAccessoryQuantity: accessoryBill.quantity,
            accessoryTotalAmount: accessoryBill.quantity * accessoryBill.rate
          })
        }
        if (simBill) {
          initStatus['simQuantity'] = simBill.quantity
          this.setState({
            simQuantity: simBill.quantity,
            oldSimQuantity: simBill.quantity,
            simTotalAmount: simBill.quantity * simBill.rate
          })
        }
      }
    }

    // Take care of non mandatory fields
    // TODO: Explore handling this in the query
    // console.log(fetchedSubscriptionData.data.getSubscriptions.nextPaymentDate, 'nextpay')
    var fields = {
      initStatus: initStatus,
      billingFrequencyId: data.partnerSubscription.billingFrequency.id
    }
    this.setState(fields)
  }

  render() {
    const { classes } = this.props
    const { isLoading } = this.state
    return (
      <div className={classes.root}>
        <Grid container spacing={16} direction="row">
          <Grid item>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={this.handleCancelClick}
            >
              <ArrowBackIcon className={classes.iconSmall} />
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="headline">Edit Subscription</Typography>
          </Grid>
          {!isLoading && (
            <Grid item container spacing={16} direction="row">
              <Grid item xs={12}>
                <ShowSubDetails
                  subscriptionData={this.state.subscriptionData}
                  isUpdateConfDialogOpen={this.state.isUpdateConfDialogOpen}
                  isCancelConfDialogOpen={this.state.isCancelConfDialogOpen}
                  billingFrequencyId={this.state.billingFrequencyId}
                  totalQuantity={this.state.totalQuantity}
                  deviceQuantity={this.state.deviceQuantity}
                  accessoryQuantity={this.state.accessoryQuantity}
                  simQuantity={this.state.simQuantity}
                  softwareQuantity={this.state.softwareQuantity}
                  deviceTotalAmount={this.state.deviceTotalAmount}
                  softwareTotalAmount={this.state.softwareTotalAmount}
                  accessoryTotalAmount={this.state.accessoryTotalAmount}
                  simTotalAmount={this.state.simTotalAmount}
                  handleChange={this.handleChange}
                  handleCancelSubscription={this.handleCancelSubscription}
                  handleUpdateSubscription={this.handleUpdateSubscription}
                  handleCancelClick={this.handleCancelClick}
                  handleUpdateClick={this.handleUpdateClick}
                  cancelNegativeResponseHandler={
                    this.handleCancelNegativeResponse
                  }
                  cancelPositiveResponseHandler={this.handleCancelSubscription}
                  updateNegativeResponseHandler={
                    this.handleUpdateNegativeResponse
                  }
                  updatePositiveResponseHandler={this.handleUpdateSubscription}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </div>
    )
  }
}
EditPartnerSubscription.propTypes = {
  classes: PropTypes.object.isRequired
}

const withApolloClient = Component => props => (
  <ApolloConsumer>
    {client => <Component client={client} {...props} />}
  </ApolloConsumer>
)

export default withStyles(style)(
  withApolloClient(withSharedSnackbar(EditPartnerSubscription))
)



// WEBPACK FOOTER //
// ./src/components/Pages/EditPartnerSubscription/index.jsx